import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, useStore } from 'react-redux';

import { registerSideEffects } from './sideEffects/main';
import { AuthCombinedState, rootReducer } from './reducers/main';

export function buildStore(preloadedState?: Partial<AuthCombinedState>) {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState: preloadedState as any,
    devTools: process.env.NODE_ENV !== 'production',
  });

  registerSideEffects(store);

  return store;
}

export const store: ReturnType<typeof buildStore> = buildStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = ReturnType<typeof buildStore>;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
